<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">James Grant</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgments">Acknowledgments</a></li><li id="toc-li-5"><a href="#/text/ch005#part-i">Part I</a></li><li id="toc-li-7"><a href="#/text/ch006#part-ii">Part II</a></li><li id="toc-li-8"><span href="#/text/ch007#part-iii" title="Link target outside of Sample">Part III</span></li><li id="toc-li-9"><span href="#/text/ch008#part-iv" title="Link target outside of Sample">Part IV</span></li><li id="toc-li-10"><span href="#/text/ch009#part-v" title="Link target outside of Sample">Part V</span></li><li id="toc-li-11"><span href="#/text/ch010#part-vi" title="Link target outside of Sample">Part VI</span></li><li id="toc-li-12"><span href="#/text/ch011#part-vii" title="Link target outside of Sample">Part VII</span></li><li id="toc-li-13"><span href="#/text/ch012#part-viii" title="Link target outside of Sample">Part VIII</span></li><li id="toc-li-14"><span href="#/text/ch013#part-ix" title="Link target outside of Sample">Part IX</span></li><li id="toc-li-15"><span href="#/text/ch014#epilogue" title="Link target outside of Sample">Epilogue</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?902af78c